import { useState } from "react";
import { type PointsHistoryItem } from "@/hooks/useRewards";
import { useNavigate } from "react-router-dom";

interface PointsHistoryProps {
  history: PointsHistoryItem[];
  totalPoints: number;
}

export default function PointsHistory({ history, totalPoints }: PointsHistoryProps) {
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate();

  const displayed = showAll ? history : history.slice(0, 5);

  if (history.length === 0) {
    return (
      <div className="bg-[#111] border border-white/8 rounded-3xl p-8 flex flex-col items-center gap-4 text-center">
        <div className="w-16 h-16 flex items-center justify-center bg-amber-400/10 border border-amber-400/20 rounded-2xl">
          <i className="ri-history-line text-amber-400 text-2xl"></i>
        </div>
        <div>
          <p className="text-white text-sm font-black" style={{ fontFamily: "'Cairo', sans-serif" }}>لا يوجد سجل نقاط بعد</p>
          <p className="text-gray-500 text-xs mt-1 leading-relaxed" style={{ fontFamily: "'Cairo', sans-serif" }}>
            اطلب الآن واستلم طلبك لتبدأ في كسب النقاط
          </p>
        </div>
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2 bg-amber-400 hover:bg-amber-300 text-black font-black px-5 py-2.5 rounded-xl text-sm transition-all cursor-pointer whitespace-nowrap"
          style={{ fontFamily: "'Cairo', sans-serif" }}
        >
          <i className="ri-store-2-line"></i>
          تسوق الآن
        </button>
      </div>
    );
  }

  return (
    <div className="bg-[#111] border border-white/8 rounded-3xl p-6">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-white text-base font-black flex items-center gap-2" style={{ fontFamily: "'Cairo', sans-serif" }}>
          <i className="ri-history-line text-amber-400"></i>
          سجل النقاط
          <span className="bg-amber-400/10 border border-amber-400/20 text-amber-400 text-[10px] font-black px-2 py-0.5 rounded-full">
            {history.length}
          </span>
        </h2>
        <div className="flex items-center gap-1.5 bg-green-400/10 border border-green-400/20 rounded-full px-3 py-1">
          <i className="ri-coins-line text-green-400 text-xs"></i>
          <span className="text-green-400 text-xs font-black" style={{ fontFamily: "'Cairo', sans-serif" }}>
            {totalPoints} نقطة
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-2">
        {displayed.map((item, idx) => {
          const date = new Date(item.date).toLocaleDateString("ar-SA", {
            year: "numeric", month: "short", day: "numeric",
          });
          return (
            <div
              key={idx}
              className="flex items-center gap-3 bg-[#1a1a1a] hover:bg-[#1f1f1f] rounded-2xl px-4 py-3.5 border border-white/5 transition-colors cursor-pointer"
              onClick={() => navigate(`/order/${item.orderRef}`)}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-green-400/10 border border-green-400/20 rounded-xl flex-shrink-0">
                <i className="ri-add-circle-line text-green-400 text-base"></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-white text-xs font-bold" style={{ fontFamily: "'Cairo', sans-serif" }}>
                  طلب #{item.orderRef}
                </p>
                <p className="text-gray-500 text-[11px] mt-0.5" style={{ fontFamily: "'Cairo', sans-serif" }}>
                  {date} · {item.orderTotal.toLocaleString()} ر.س
                </p>
              </div>
              <div className="text-left flex-shrink-0">
                <p className="text-green-400 text-base font-black" style={{ fontFamily: "'Cairo', sans-serif" }}>
                  +{item.pointsEarned}
                </p>
                <p className="text-gray-600 text-[10px] text-left" style={{ fontFamily: "'Cairo', sans-serif" }}>نقطة</p>
              </div>
              <i className="ri-arrow-left-s-line text-gray-700 text-sm flex-shrink-0"></i>
            </div>
          );
        })}
      </div>

      {history.length > 5 && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="w-full mt-3 flex items-center justify-center gap-2 bg-[#1a1a1a] hover:bg-[#222] border border-white/5 text-gray-400 hover:text-white text-xs font-bold py-3 rounded-2xl transition-all cursor-pointer"
          style={{ fontFamily: "'Cairo', sans-serif" }}
        >
          <i className={`${showAll ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-sm`}></i>
          {showAll ? "عرض أقل" : `عرض الكل (${history.length})`}
        </button>
      )}
    </div>
  );
}
